import React, { useState } from "react";
import { brand } from "../../brands/index.js";
import { t } from "../../i18n/index.js";

const isMinimal = brand.theme.landingStyle === "minimal";

function getSamples() {
  const host = brand.gatewayHost;
  return [
    {
      id: "curl",
      label: "curl",
      code: `curl -X GET "https://${host}/open/v1/products/search?keyword=phone%20case&country=us&page=1&page_size=5" \\
  -H "Authorization: Bearer sk_live_xxxxxxxxxxxxxxxx"`,
    },
    {
      id: "python",
      label: "Python",
      code: `import requests

resp = requests.get(
    "https://${host}/open/v1/products/search",
    headers={"Authorization": "Bearer sk_live_xxxxxxxxxxxxxxxx"},
    params={"keyword": "phone case", "country": "us", "page_size": 5},
)

print(resp.json())`,
    },
    {
      id: "node",
      label: "Node.js",
      code: `const resp = await fetch(
  "https://${host}/open/v1/products/search?keyword=phone+case&country=us&page_size=5",
  { headers: { Authorization: "Bearer sk_live_xxxxxxxxxxxxxxxx" } },
);

console.log(await resp.json());`,
    },
  ];
}

export function QuickStartBlock() {
  const s = t.quickStart;
  const SAMPLES = getSamples();
  const [active, setActive] = useState(SAMPLES[0].id);
  const [copied, setCopied] = useState(false);
  const current = SAMPLES.find((sample) => sample.id === active)!;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(current.code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* no-op */
    }
  };

  return (
    <section style={{ margin: isMinimal ? "96px 0" : "48px 0" }}>
      <header style={{ marginBottom: isMinimal ? "28px" : "16px", textAlign: isMinimal ? "center" : "left" }}>
        <div
          style={{
            fontSize: "12px",
            fontWeight: 600,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            color: isMinimal ? "var(--muted-foreground)" : "var(--brand-primary)",
            marginBottom: "8px",
          }}
        >
          {s.eyebrow}
        </div>
        <h2
          style={{
            margin: 0,
            fontSize: isMinimal ? "clamp(28px, 4vw, 40px)" : "26px",
            fontWeight: 600,
            letterSpacing: "-0.02em",
          }}
        >
          {s.heading}
        </h2>
      </header>

      <div
        style={{
          border: isMinimal ? "1px solid rgba(255,255,255,0.08)" : "1px solid var(--border)",
          borderRadius: isMinimal ? "12px" : "var(--radius)",
          overflow: "hidden",
          background: isMinimal ? "#0b0f17" : "var(--card)",
          boxShadow: isMinimal
            ? "0 24px 48px -28px rgba(0,0,0,0.3), 0 4px 16px -8px rgba(0,0,0,0.12)"
            : undefined,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 12px",
            borderBottom: isMinimal
              ? "1px solid rgba(255,255,255,0.06)"
              : "1px solid var(--border)",
            background: isMinimal
              ? "linear-gradient(180deg, #151a24 0%, #0e131c 100%)"
              : "color-mix(in oklab, var(--muted) 60%, transparent)",
          }}
        >
          <div style={{ display: "flex", gap: "2px" }}>
            {SAMPLES.map((sample) => (
              <button
                key={sample.id}
                onClick={() => setActive(sample.id)}
                style={{
                  padding: "10px 14px",
                  fontSize: "13px",
                  fontWeight: 500,
                  color: isMinimal
                    ? active === sample.id
                      ? "#f1f5f9"
                      : "#64748b"
                    : active === sample.id
                      ? "var(--foreground)"
                      : "var(--muted-foreground)",
                  background: "transparent",
                  border: "none",
                  borderBottom:
                    active === sample.id
                      ? "2px solid var(--brand-primary)"
                      : "2px solid transparent",
                  marginBottom: "-1px",
                  fontFamily: isMinimal ? "var(--font-mono)" : undefined,
                  letterSpacing: isMinimal ? "0.02em" : undefined,
                }}
              >
                {sample.label}
              </button>
            ))}
          </div>

          <button
            onClick={handleCopy}
            style={{
              padding: "5px 12px",
              fontSize: "12px",
              color: isMinimal
                ? copied
                  ? "#7dd3fc"
                  : "#94a3b8"
                : copied
                  ? "var(--brand-primary)"
                  : "var(--muted-foreground)",
              background: "transparent",
              border: isMinimal
                ? "1px solid rgba(255,255,255,0.1)"
                : "1px solid var(--border)",
              borderRadius: "6px",
            }}
          >
            {copied ? s.copied : s.copy}
          </button>
        </div>

        <pre
          style={{
            margin: 0,
            padding: "18px 20px",
            fontSize: "13px",
            lineHeight: 1.65,
            fontFamily: "var(--font-mono)",
            color: isMinimal ? "#e2e8f0" : "var(--foreground)",
            background: "transparent",
            overflowX: "auto",
            whiteSpace: "pre",
          }}
        >
          <code>{current.code}</code>
        </pre>
      </div>

      <p
        style={{
          margin: "12px 0 0",
          fontSize: "13px",
          color: "var(--muted-foreground)",
          textAlign: isMinimal ? "center" : "left",
        }}
      >
        {s.noApiKey}
        <a
          href={brand.applyApiKeyUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            marginLeft: "4px",
            color: "var(--brand-primary)",
            fontWeight: 500,
          }}
        >
          {s.applyLink}
        </a>
      </p>
    </section>
  );
}
